<section class="browse-application pt-5 pb-5 pt-xl-0">
  <div class="container">
    <div class="content-heading mb-4">
      <h1 class="fw-semibold cv-text-dark">Browse By Applications</h1>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <div class="row">
          <div class="col text-center" *ngFor="let item of finalData">
            <a class="grid-item d-flex text-decoration-none  icon-container cursor"
              [ngClass]="item?.vehicle_application_name == 'View All' ? 'color' :'cv-text-dark' ">
              <div class="icon ">
                <a (click)="redirect(item?.vehicle_application_name)">
                  <img
                    [src]="item?.vehicle_application_name == 'View All' ? environment1 + 'assets/images/grid-circle.svg' :item?.image_path"
                    loading="lazy"
                    [ngStyle]="item?.vehicle_application_name === 'View All' ? {'width':'50px','height':'50px'} : {'width':'81px','height':'81px'}">
                </a>
              </div>
              <a (click)="redirect(item?.vehicle_application_name)">
                <p class="fw-semibold">{{item?.vehicle_application_name}}</p>
              </a>
            </a>
          </div>
        </div>

      </div>

    </div>
  </div>
</section>

<div class="modal fade" id="imageFullScreenModeModal" tabindex="-1" role="dialog"
  aria-labelledby="imageFullScreenModeModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="col-12 col-sm-12 text-end">
          <button type="button" class="close" (click)="imagePreviewpopupClose()">
            <span aria-hidden="true">
              <img [src]="environment1 + 'images/new-images/browse.svg'" alt="browse" loading="lazy">
            </span>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <section class="browse-application pt-5 pb-5 pt-xl-0">
          <div class="container">
            <div class="row">
              <div class="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <div class="row">
                  <div class="content-heading mb-4 search-p-scroll search-control ">
                    <input type="search" [(ngModel)]="searchData" (input)="search(searchData)"
                      class="form-control form-control-sm search-control" placeholder="Search by Application" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div class="row scroll">
                  <div class="col text-center" style="margin:2px;" *ngFor="let item of filterData">
                    <a class="grid-item d-flex text-decoration-none  icon-container cursor"
                      [ngClass]="item?.vehicle_application_name == 'View All' ? 'color' :'cv-text-dark' ">
                      <div>
                        <a (click)="redirect(item?.vehicle_application_name)">
                          <img
                            [src]="item?.vehicle_application_name == 'View All' ?  environment1 + 'assets/images/grid-circle.svg' :item?.image_path"
                            loading="lazy" width="50px" height="50px">
                        </a>
                      </div>
                      <a (click)="redirect(item?.vehicle_application_name)">
                        <p class="fw-semibold">{{item?.vehicle_application_name}}</p>
                      </a>
                    </a>
                  </div>
                  <div *ngIf="filterData?.length == 0">
                    <p>No Record Found</p>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
